/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { AdaptiveCardContainer as AdaptiveCard } from './AdaptiveCard.container';
